export default {
  header: {
    nav: "Home",
    nav2: "Payment Products",
    nav2_1: "Global Acquiring",
    nav2_2: "Global Collection Accounts",
    nav2_3: "Global Payout",
    nav3: "Tech Services",
    nav3_1: "QR Payment System",
    nav3_2: "IM Tool",
    nav4: "Developers",
    nav4_1: "API Docs",
    nav5: "About",
    nav5_1: "Company Profile",
    nav5_2: "Contact",
    login: "LOGIN"
  },
  footer: {
    statement: "AML Statement",
    termuse: "Terms of Service",
    privacy: "Privacy Policy",
    copyright: "© Singloh Technology Limited All Rights Reserved.",
    icp: "ICP License: 浙ICP备2024129281号-3"
  },
  home: {
    banner1: "Complete Solution to All your",
    banner2: "Payment Needs",
    banner3:
      "We dedicate in delivering end-to-end global transaction solutions,seamlessly accept international payments, send cross-border transfers, and manage multi-currency accounts. By integrating localized payment methods and regional networks worldwide,we transform transaction complexity into strategic growth opportunities for your global operations.",
    ref: "Contact With Us",
    part1: {
      tit: "Global Acquiring Borderless Reach",
      tips: "Secure & efficient Payment solutions with worldwide coverage",
      p:
        "Directly connect with Visa, Mastercard, JCBand global card organizations",
      p2: "Support most mainstream e-walletsfor higher payment acceptance",
      p3:
        "Enable hundreds of regional methodsacross Europe,Americas, Africa & Asia-Pacific",
      btn_txt: "Learn More"
    },
    part2: {
      tit: "Global Transfers Secure & Swift",
      tips: "Empower global disbursements with precision and ease",
      p: "Diverse Channels",
      p2: "Global Coverage",
      p3: "Multi-Currency",
      p4: "Fast Processing",
      p5: "Quick Settlement"
    },
    part3: {
      tit: "Global Accounts Multi-Currency Mastery",
      tips:
        "Tailored for global businesses to streamlinemulti-currency fund management",
      p: "Local accounts with lower fees",
      p2: "Efficient transaction service, ensuring swift arrival of funds",
      p3:
        "Centralize balances across all accountswith real-time fund allocation and management"
    },
    sec1: {
      tit: "Innovation-Driven",
      tit2: "Business Expansion",
      tips: "Redefining boundaries through payment-integrated ecosystems",
      subtit: "QR Payment System",
      subtit_p:
        "Central bank-level QR code payment system supporting cross-border clearing. Successfully deployed in multiple countries.",
      subtit2: "Instant Messaging Tool",
      subtit2_p:
        "Secure IM platform with integrated payment functions, supporting various transaction scenarios."
    },
    sec2: {
      tit: "API Intearation Made",
      tit2: "Interaration Effortless",
      tips: "Accelerate development with detailed documentation and tools.",
      part1: {
        tit: "Complete",
        tit2: "API Docs",
        tips: "Detailed specifications",
        tips2: "Request/response formats"
      },
      part2: {
        tit: "Practical",
        tit2: "Code Samples",
        tips: "Ready-to-use examples",
        tips2: "Accelerate integration"
      },
      part3: {
        tit: "Flexible",
        tit2: "Api support",
        tips: "Multi-language support",
        tips2: "Custom integration"
      },
      part4: {
        tit: "Community",
        tit2: "Resource",
        tips: "1v1 support",
        tips2: "Quick issue resolution"
      }
    },
    con_t: "Start Your",
    con_t2: "Global Acquiring Journey",
    news: {
      tit: "News"
    }
  },
  acq: {
    th: "Global Acquiring",
    tit: "Connect to Global Markets",
    tit2:
      "Multi-currency/multi-channel payment acceptance for seamless checkout experience",
    sec1: {
      tit: "Global Payment Methods",
      p1: "Integrated with Visa/Mastercard/JCB for global coverage",
      p2: "Support major e-wallets across regions",
      p3: "100+ local payment methods through licensed network",
      th4: "Supported Wallets"
    },
    sec2: {
      t1: "Diverse Options",
      tips1: "Credit/debit cards, e-wallets, bank transfers, etc.",
      t2: "Borderless Payments",
      tips2: "Accept 150+ currencies with flexible infrastructure",
      t3: "Multiple Integration",
      tips3: "Checkout page, API direct connection, etc.",
      t4: "Advanced Security",
      tips4: "PCI-DSS compliant with E2E encryption"
    },
    sec3: {
      tit: "Smart Risk Engine",
      t1: "Compliance",
      tips1: "Meet international payment regulations",
      t2: "Real-time Monitoring",
      tips2: "AI/ML powered risk detection",
      t3: "Chargeback Service",
      tips3: "Professional dispute resolution",
      t4: "Multi-layer Protection",
      tips4: "Behavior analysis & geo-verification"
    },
    sec4: {
      tit: "Custom Solutions",
      tit2: "For Every Market",
      tips: "Flexible integration solutions tailored to business needs"
    }
  },
  acc: {
    th: "Collection Accounts",
    tit: "Global Collection Solution",
    tit2: "Multi-currency accounts for efficient cross-border fund management",
    th2: "Online Collection Anytime",
    sec1: {
      tit: "Multi-Currency Accounts",
      tips: "USD, EUR, GBP, JPY and more"
    },
    sec2: {
      t1: "Cross-border Support",
      tips1: "Simplify international collection processes",
      t2: "Global Coverage",
      tips2: "Access key markets without multiple accounts",
      t3: "Real-time Management",
      tips3: "Track balances & transactions in real-time",
      t4: "Cost Efficiency",
      tips4: "Reduce FX loss & transfer fees",
      t5: "Bank-grade Security",
      tips5: "Advanced security protocols",
      t6: "Auto Reconciliation",
      tips6: "Seamless accounting integration",
      t7: "Full Compliance",
      tips7: "Meet global financial regulations"
    }
  },
  pay: {
    th: "Global Payout",
    tit: "Fast & Secure Payments",
    sec1: {
      t1: "Global Coverage",
      tips1: "110+ countries/regions supported",
      t2: "Diverse Networks",
      tips2: "SWIFT/ACH/FEDWIRE/SEPA + local rails",
      t3: "Fast Settlement",
      tips3: "0-3 business days processing",
      t4: "Secure Transactions",
      tips4: "Advanced security controls",
      t5: "Simple Operation",
      tips5: "User-friendly interface & automation"
    },
    sec2: {
      t1: "Regions",
      t2: "Bank Accounts",
      t3: "Mobile Wallets",
      t4: "Cash Points"
    },
    africa: "Africa",
    asia: "Asia",
    europe: "Europe",
    latin: "Latin America & Caribbean",
    north: "South America",
    oceania: "Oceania"
  },
  system: {
    th: "QR Payment System",
    th2: "Custom Clearing Solutions",
    tips:
      "NuwaPay's QRPS is an advanced QR-based system for central banks, supporting both system integration and new mobile payment infrastructures. Enables cross-border settlement through partnerships with global clearing networks.",
    sec: {
      t1: "Custom Solutions",
      tips1: "Adaptable to existing financial infrastructures",
      t2: "Enhanced Oversight",
      tips2: "Improved transaction monitoring & analytics",
      t3: "Cross-border Settlement",
      tips3: "Integration with global clearing networks",
      t4: "System Advantages",
      tips4: "Scalable & secure architecture",
      t5: "Global Deployment",
      tips5: "Replicable model for developing markets",
      t6: "User Experience",
      tips6: "Intuitive interface for all users",
      t7: "Case Study: Nigeria NQR",
      tips7:
        "Successfully implemented nationwide QR system with complete regulatory framework"
    }
  },
  tool: {
    th: "IM Payment Tool",
    tips:
      "Budchat - NuwaPay's integrated IM platform with bank-grade wallet features, currently live in Nigeria.",
    sec: {
      t1: "Payment Integration",
      tips1: "Supports B2C/C2B/C2C transactions within chat",
      t2: "Bank-grade Wallet",
      tips2: "Secure wallet for transfers & cross-border payments",
      t3: "Seamless Experience",
      tips3: "In-chat payment functionality",
      t4: "Nigeria Deployment",
      tips4: "Fully operational with market recognition",
      t5: "Data Security",
      tips5: "Multi-layer encryption & compliance",
      t6: "UX Design",
      tips6: "Intuitive multi-language interface"
    }
  },
  about: {
    th: "Company Profile",
    tips:
      " Singloh Technology Limited was founded in 2019 by the founders of the giants in China's domestic mobile payment sector. The Company focuses on helping overseas countries realize the digital transformation of mobile payment, providing advanced QR code technology services and barcode payment and settlement systems to overseas central banks and acquiring institutions. Singloh has successfully built payment systems for many African countries, and provided local users and merchants with value-added services such as mobile wallets and digital management products, comprehensively covering various scenarios in the payment ecosystem and providing industry-leading solutions.",
    tips2: `With customer success as its mission, the company has set up branches in Hong Kong, Singapore, Indonesia, Tanzania, Nigeria, Kazakhstan and other places, and built a one-stop platform for cross-border payment and capital clearing with "The Belt and Road" as its core business development. It is committed to solving the problems of capital receipt and payment in global business expansion for enterprises. To help enterprises achieve safe and efficient capital circulation around the world, provide currency exchange, foreign exchange settlement and distribution services. At present, Singloh has obtained PCI-DSS international payment industry security certification, and its payment capability covers VISA, MASTERCARD, JCB and other international card organizations and more than 100 global e-wallet receipt services. The company's business covers more than 110 countries and regions, supporting more than 15 mainstream settlement currencies.`
  },
  conUs: {
    th: "Contact Us",
    firstName: "Last Name",
    lastName: "First Name",
    email: "Work Email",
    phone: "Work Number",
    companyName: "Company Name",
    companyAddress: "Operating Regions",
    check1: "I have read and agree to ",
    check2: "Privacy Policy",
    check3: "",
    submit: "Submit",
    phr1: "3",
    phr2: "char",
    phr3: "Valid email required",
    phr4: "Phone number required",
    phr5: "Region",
    phr6: "Company name required",
    phr7: "Business regions required"
  },

  address: {
    address: "Address",
    hk: "香港(Hong Kong SAR,China)"
  },
  error: {
    lastName: "Please input last name",
    firstName: "Please input first name",
    email: "Please input email",
    phone: "Please input phone",
    area: "Please select area",
    companyName: "Please input company name",
    checked: "Please read and agree to NuwaPay's Privacy Policy."
  },
  login: {
    tit: "Login to your account",
    txt: "Welcome back, you’ve been missed!",
    tips: "New to NuwaPay?",
    tips2: "Click here to Sign up",
    logo: {
      txt: "Login to NuwaPay"
    }
  }
};



// WEBPACK FOOTER //
// ./src/locale/lang/en.js